import { useContext, useEffect, useState } from "react";
import { MainContainer } from "../Components/MainContainer";
import { SearchBarComponent } from "../Components/SearchBarComponent";
import { Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, Pagination, PaginationItem, PaginationLink, } from "reactstrap";
import { UserType } from "../Types/UsersType";
import { Api } from "../Services/CohortServices";
import { FaEdit, FaTrash } from "react-icons/fa";
import { authContext } from "../Context/AuthContext";
import { ToasterAdviser } from "../Components/ToasterComponent";

export const UsersList = () => {
  const { user } = useContext(authContext);
  const [users, setUsers] = useState<UserType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserType | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [userToastedId, setUserToastedId] = useState<string | null>(null);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editPassword, setEditPassword] = useState("");
  const [filteredUsers, setFilteredUsers] = useState<UserType[]>([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const pagesPerBlock = 3;


  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await Api.get("/users");
      setUsers(response.data.Users);
    } catch (error) {
      setError("Não houve retorno do servidor, tente novamente mais tarde.");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    if (filteredUsers.length === 0) {
      fetchUsers();
    }
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line
  }, []);

  const handleEdit = (user: UserType) => {
    setSelectedUser(user);
    setEditName(user.name);
    setEditEmail(user.email || "");
    setEditPassword(""); // Deixe a senha em branco
    setEditModal(true);
  };

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      await Api.put(`/users/${selectedUser?.id}`, {
        name: editName,
        email: editEmail,
        password: editPassword,
      });
      setUserToastedId(selectedUser?.id?.toString() || null)
      setSuccess("Usuário atualizado com sucesso!");
      setTimeout(() => {
        setEditModal(false);
        setSuccess(null);
        setError(null);
        setUserToastedId(null)
        setUsers((prev) =>
          prev.map((user) =>
            user.id === selectedUser?.id
              ? { ...user, name: editName, email: editEmail }
              : user
          )
        );
      }, 3000);

    } catch (error) {
      console.error("Erro ao atualizar o usuário:", error);
      setError("Erro ao atualizar o usuário. Tente novamente.");
      setTimeout(() => {
        setError(null);
        setSuccess(null);
      }, 3000);
    } finally {
      setIsUpdating(false);
    }
  };

  const deleteModal = (user: UserType) => {
    setSelectedUser(user);
    setConfirmDelete(true)
  }
  const handleDelete = async (userId: number) => {
    //confirmar primeiro via modal
    try {
      await Api.delete(`/users/${userId}`);
      setUserToastedId(userId.toString())
      setSuccess("Usuário deletado com sucesso!");
      setTimeout(() => {
        setSuccess(null);
        setError(null);
        setUserToastedId(null)
        setUsers((prev) => prev.filter((user) => user.id !== userId));
      }, 3000);
    } catch (error) {
      setError("Erro ao deletar o usuário. Tente novamente.");
      setTimeout(() => {
        setError(null);
        setSuccess(null);
        setUserToastedId(null)
      }, 3000);
      console.error("Erro ao deletar o usuário:", error);
    }
  };



  const colaborators = (filteredUsers.length > 0 ? filteredUsers :(users.length > 0 ? users : [])) as UserType[];

  const totalPages = Math.ceil(users.length / itemsPerPage);
  const currentUsers = colaborators.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const currentBlock = Math.ceil(currentPage / pagesPerBlock);
  const startPage = (currentBlock - 1) * pagesPerBlock + 1;
  const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <MainContainer>
      <>
        <div className="main-content">
          <div className="mt-1">
            <Col md={10} className="offset-md-1">
              <div style={{ fontSize: '2.25rem ', fontWeight: '900 ', color: '#000' }}>Usuários Cadastrados</div>
              {user && user.access_level === 'admin' &&
                <SearchBarComponent<UserType>
                  searchPlaceholder="Pesquisar por nome ou e-mail..."
                  buttonName="Criar Usuário"
                  buttonRoute="/createuser"
                  setFilteredClient={setFilteredUsers}
                  isLoading={setIsLoading}
                />
              }
              {isLoading ? (
                <p className="d-flex align-items-center mt-4">Carregando...</p>
              ) : error ? (
                <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>
              ) : (
                <div
                  style={{
                    backgroundColor: "inherit",
                    maxHeight: "70%",
                    overflowY: "auto",
                    border: "none",
                    padding: "0.5rem",
                    marginTop: "1.5rem",
                  }}
                >
                  {user && (filteredUsers.length > 0 ? filteredUsers : currentUsers)?.map((userParam:UserType) => {
                    return (
                    <div
                      key={userParam.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <div>
                        <p style={{ margin: 0, fontWeight: "500", fontSize: "1.2rem" }}><strong>Nome: </strong>{userParam.name}</p>
                        <small style={{ margin: 0, fontWeight: "500", fontSize: "0.8rem" }}><strong>Email: </strong>{userParam.email}</small>
                      </div>
                      <div style={user && user?.access_level === "admin" ? { display: "flex" } : { display: "none" }}>
                        <FaEdit
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={() => handleEdit(userParam)}
                        />
                        <FaTrash
                          style={{ cursor: "pointer" }}
                          onClick={() => deleteModal(userParam)}
                        />
                      </div>

                      {/* Toast de sucesso */}
                      {(userParam.id !== undefined && userToastedId === userParam.id.toString()) && (success || error) && (
                        <ToasterAdviser
                          type={success ? "success" : "error"}
                          message={success || error}
                          icon={success ? "success" : "error"}
                        />
                      )}
                    </div>
                  )})}
                  <div className="d-flex justify-content-end">
                    <Pagination className="mt-3 text-end me-3">
                      {/* Botão "Primeiro" */}
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink onClick={() => handlePageChange(1)}>
                          Primeiro
                        </PaginationLink>
                      </PaginationItem>

                      {/* Botão "Anterior" */}
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink
                          previous
                          onClick={() =>
                            handlePageChange(Math.max(currentPage - 1, 1))
                          }
                        />
                      </PaginationItem>

                      {/* Páginas do bloco atual */}
                      {Array.from(
                        { length: endPage - startPage + 1 },
                        (_, index) => startPage + index
                      ).map((page) => (
                        <PaginationItem key={page} active={currentPage === page}>
                          <PaginationLink onClick={() => handlePageChange(page)}>
                            {page}
                          </PaginationLink>
                        </PaginationItem>
                      ))}

                      {/* Botão "Próximo" */}
                      <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink
                          next
                          onClick={() =>
                            handlePageChange(Math.min(currentPage + 1, totalPages))
                          }
                        />
                      </PaginationItem>

                      {/* Botão "Último" */}
                      <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink onClick={() => handlePageChange(totalPages)}>
                          Último
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </div>
                </div>
              )}
            </Col>
          </div>
        </div>

        {/* Modal de edição */}
        <Modal isOpen={editModal} toggle={() => setEditModal(false)}>
          <ModalHeader toggle={() => setEditModal(false)}>Editar Usuário</ModalHeader>
          <ModalBody>
            <Label for="name">Nome</Label>
            <Input
              type="text"
              placeholder="Nome"
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              className="mb-3"
            />
            <Label for="email">E-mail</Label>
            <Input
              type="email"
              placeholder="E-mail"
              value={editEmail}
              onChange={(e) => setEditEmail(e.target.value)}
              className="mb-3"
            />
            {user?.id === selectedUser?.id && (
              <>
                <Label for="password">Senha</Label>
                <Input
                  type="password"
                  placeholder="Senha"
                  value={editPassword}
                  onChange={(e) => setEditPassword(e.target.value)}
                  className="mb-3"
                />
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              className="cohort_create_button"
              onClick={handleUpdate}
              disabled={isUpdating}
            >
              {isUpdating ? "Atualizando..." : "Atualizar"}
            </Button>{" "}
            <Button color="secondary" onClick={() => setEditModal(false)}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal de confirmação de exclusão */}
        <Modal isOpen={confirmDelete} toggle={() => setConfirmDelete(false)}>
          <ModalHeader toggle={() => setConfirmDelete(false)}>Confirmar Exclusão</ModalHeader>
          <ModalBody>
            Você tem certeza que deseja excluir o usuario {selectedUser?.name}
          </ModalBody>
          <ModalFooter>
            <Button
              className="cohort_create_button"
              onClick={() => {
                if (selectedUser) {
                  handleDelete(selectedUser?.id)
                }
                setConfirmDelete(false);
              }}
            >
              Confirmar
            </Button>{" "}
            <Button color="secondary" onClick={() => setConfirmDelete(false)}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

      </>
    </MainContainer>
  );
};
